/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { getSubscriptionCenterLink } from '../../axios/getSubscriptionCenterLink'
import type {
	GetSubscriptionCenterLinkError,
	GetSubscriptionCenterLinkResponse,
} from '../../types/GetSubscriptionCenterLink'

export const getSubscriptionCenterLinkQueryKey = () => [{ url: '/notifications/subscription-center-link' }] as const

export type GetSubscriptionCenterLinkQueryKey = ReturnType<typeof getSubscriptionCenterLinkQueryKey>

/** @see backend/nexus/app/Http/Controllers/GetSubscriptionCenterLinkController.php GetSubscriptionCenterLinkController::__invoke */
export function getSubscriptionCenterLinkQueryOptions(config?: AxiosRequestConfig) {
	return queryOptions<
		GetSubscriptionCenterLinkResponse,
		AxiosError<GetSubscriptionCenterLinkError>,
		GetSubscriptionCenterLinkResponse,
		GetSubscriptionCenterLinkQueryKey
	>({
		queryKey: getSubscriptionCenterLinkQueryKey(),
		queryFn: ({ signal }) => getSubscriptionCenterLink({ signal, ...config }).then(res => res.data),
	})
}

/** @see backend/nexus/app/Http/Controllers/GetSubscriptionCenterLinkController.php GetSubscriptionCenterLinkController::__invoke */
export function useGetSubscriptionCenterLink<TSelectData = GetSubscriptionCenterLinkResponse>(
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					GetSubscriptionCenterLinkResponse,
					AxiosError<GetSubscriptionCenterLinkError>,
					TSelectData,
					GetSubscriptionCenterLinkQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<GetSubscriptionCenterLinkError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...getSubscriptionCenterLinkQueryOptions(),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/app/Http/Controllers/GetSubscriptionCenterLinkController.php GetSubscriptionCenterLinkController::__invoke */
export function useGetSubscriptionCenterLinkSuspense<TSelectData = GetSubscriptionCenterLinkResponse>(
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					GetSubscriptionCenterLinkResponse,
					AxiosError<GetSubscriptionCenterLinkError>,
					TSelectData,
					GetSubscriptionCenterLinkQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<GetSubscriptionCenterLinkError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...getSubscriptionCenterLinkQueryOptions(),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
